import { useEffect, type ReactElement } from "react";
import { TabPanel, Tab } from "@bracket/react-tabs";
import { usePointsStore } from "@stores/points";
import { BarsBanner } from "./BarsBanner";
import { Boosts } from "./Boosts";
import { LeaderBoard } from "./LeaderBoard";
import { Loader } from "@bracket/react-loader";
import { pointsToPercent, formattedPoints } from "@helpers";
import { getTimedImageLoc } from "@helpers";
import { ReactCarousel, ReactCarouselItem } from "@bracket/react-carousel";

import "./Bars.scss";

export const Bars = (): ReactElement => {
  const {
    initialized,
    initialize,
    _loadUserData,
    user_points,
    tvl_boost,
    early_deposit_boost,
    phase_boost,
    size_boost,
  } = usePointsStore();

  useEffect(() => {
    (async () => {
      await initialize();
    })();
  }, [initialize]);

  if (!initialized)
    return (
      <div className="loading">
        <Loader />
      </div>
    );

  return (
    <section className="bars">
      {/* {!initialized && <div>loading</div>} */}
      {initialized && <BarsBanner />}
      {/* <div className="slates">
        <div className="slate">
          <div className="data">
            <div className="label">
              <p>My [BARS]</p>
            </div>
            <div className="value">
              <h3>{formattedPoints(user_points)}</h3>
            </div>
          </div>
        </div>
        <div className="slate">
          <div className="data">
            <div className="label">
              <p>Early deposit boost</p>
            </div>
            <div className="value">
              <h3>{pointsToPercent(early_deposit_boost)}</h3>
            </div>
          </div>
        </div>
        <div className="slate">
          <div className="data">
            <div className="label">
              <p>TVL boost</p>
            </div>
            <div className="value">
              <h3>{pointsToPercent(tvl_boost)}</h3>
            </div>
          </div>
        </div>
        <div className="slate">
          <div className="data">
            <div className="label">
              <p>Phase boost</p>
            </div>
            <div className="value">
              <h3>{pointsToPercent(phase_boost)}</h3>
            </div>
          </div>
        </div>
        <div className="slate">
          <div className="data">
            <div className="label">
              <p>Size boost</p>
            </div>
            <div className="value">
              <h3>{pointsToPercent(size_boost)}</h3>
            </div>
          </div>
        </div>
      </div> */}
      {/* <div className="bars-container">
        <ReactCarousel>
          <ReactCarouselItem>
            <img
              className="broken-banner"
              src={getTimedImageLoc()}
              width="auto"
              alt="stake-reth"
            />
          </ReactCarouselItem>
        </ReactCarousel>
      </div> */}
      {initialized && (
        <TabPanel>
          <Tab label="Leaderboard" route="/bars/leaderboard">
            <LeaderBoard />
          </Tab>
          <Tab label="About boosts" route="/bars/boosts">
            <Boosts />
          </Tab>
        </TabPanel>
      )}
    </section>
  );
};
